function parseLineListPrice(el: any): number {
  const n = Number(el?.lst_price ?? el?.price_from ?? el?.price);
  return Number.isFinite(n) ? n : 0;
}

function parseLineSalePrice(el: any): number {
  const n = Number(el?.lst_price_discount ?? el?.discount);
  return Number.isFinite(n) ? n : 0;
}

/** True when line item should show/use discounted price (same rules as OrderLines). */
export function hasEffectiveDiscount(el: any): boolean {
  const list = parseLineListPrice(el);
  const sale = parseLineSalePrice(el);
  return sale > 0 && list > 0 && sale < list;
}

/** Matches cart line display in OrderLines: use discounted unit price when present. */
export function effectiveUnitPrice(el: any): number {
  const list = parseLineListPrice(el);
  const sale = parseLineSalePrice(el);
  if (sale > 0 && list > 0 && sale < list) return sale;
  if (list > 0) return list;
  return sale > 0 ? sale : 0;
}

/** Sum of list prices before line-level discounts (for coupon / API gross matching). */
export function sumCartCatalogGrossTotals(
  services: any[],
  products: any[]
): number {
  const svc = services.reduce((a: number, b: any) => a + parseLineListPrice(b), 0);
  const prd = products.reduce(
    (a: number, b: any) => a + (Number(b?.qty) || 0) * parseLineListPrice(b),
    0
  );
  return svc + prd;
}

/** Sum of service + product lines using effective (post-discount) unit prices. */
export function sumCartCatalogTotals(services: any[], products: any[]): number {
  const svc = services.reduce(
    (a: number, b: any) => a + effectiveUnitPrice(b),
    0
  );
  const prd = products.reduce(
    (a: number, b: any) =>
      a + (Number(b?.qty) || 0) * effectiveUnitPrice(b),
    0
  );
  return svc + prd;
}
